var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import FullModal from "@irati/ui/src/FullModal";
import Success from "@irati/ui/src/Success";
import CreateTeamName from "./CreateTeamName";
import AddUsersToTeam from "./AddUsersToTeam";
import ConditionalWrapper from "../../ConditionalWrapper";
var CreateTeam = /** @class */ (function (_super) {
    __extends(CreateTeam, _super);
    function CreateTeam() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDefaultState = function () {
            var currentTeam = _this.props.currentTeam;
            return {
                step: currentTeam ? 2 : 1,
                name: "",
                currentTeam: currentTeam || null,
                isTeamBeingCreated: false
            };
        };
        _this.state = __assign({}, _this.getDefaultState());
        _this.onEnter = function () {
            if (_this.props.onHide) {
                _this.props.onHide();
            }
            else {
                _this.setState(_this.getDefaultState());
            }
        };
        _this.handleCreateTeam = function (currentTeam) {
            var onSuccess = _this.props.onSuccess;
            _this.setState({ step: 2, currentTeam: currentTeam });
            if (onSuccess) {
                onSuccess();
            }
        };
        _this.handleAddUsersSuccess = function () {
            var _a = _this.props, onHide = _a.onHide, useModal = _a.useModal;
            _this.setState({ step: 3 });
            setTimeout(function () {
                if (onHide && useModal) {
                    onHide();
                }
                else {
                    _this.onEnter();
                }
            }, 2000);
        };
        _this.renderCurrentStep = function () {
            var _a = _this.state, step = _a.step, currentTeam = _a.currentTeam;
            var useModal = _this.props.useModal;
            switch (step) {
                case 1:
                    return React.createElement(CreateTeamName, { onSubmit: _this.handleCreateTeam });
                case 2:
                    return React.createElement(AddUsersToTeam, { currentTeam: currentTeam, onSuccess: _this.handleAddUsersSuccess });
                case 3:
                    return React.createElement(Success, { withMarginTop: useModal });
                default:
                    return null;
            }
        };
        return _this;
    }
    CreateTeam.prototype.render = function () {
        var _this = this;
        var _a = this.props, show = _a.show, onHide = _a.onHide, useModal = _a.useModal;
        return (React.createElement(ConditionalWrapper, { condition: useModal, wrapper: function (children) { return (React.createElement(FullModal, { show: show, onHide: onHide, onEnter: _this.onEnter }, children)); } }, this.renderCurrentStep()));
    };
    CreateTeam.defaultProps = {
        currentTeam: null,
        show: false,
        useModal: true,
        isSelectTeam: false
    };
    return CreateTeam;
}(Component));
export default CreateTeam;
